import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  parent: {
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    flex: 1,
    display: "flex",
    height: "100vh",
  },
  drawerAwareContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "24px",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    width: "90%",
    positionAnchor: "revert",
  },
  titleText: {
    color: colorsConstants.primaryText,
    fontSize: 24,
    textAlign: "center",
    flex: 1,
    marginLeft: "24px",
  },
  selectorContainer: {
    width: "100%",
  },
  selectorPaper: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
  tabsContainer: {
    borderRadius: "10px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    backgroundColor: "transparent",
    boxShadow: "none",
  },
  selectedTab: {
    p: { xs: 2, sm: 3 },
  },
  selectedTabContent: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    height: "100%",
    boxShadow: "none",
  },
  selectedTabText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 2,
  },
  searchingLoader: {
    display: "flex",
    justifyContent: "center",
    py: 4,
  },
  noItemsText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
  },
  periodSelectorContainer: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
    mb: 3,
  },
  summaryRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 2,
    flexWrap: "wrap",
    gap: 1,
  },
  totalText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    fontSize: 18,
  },
  chartContainer: {
    width: "100%",
    mb: 3,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    p: 2,
    boxSizing: "border-box",
  },
  chartTitle: {
    color: colorsConstants.primaryText,
    fontWeight: 600,
    mb: 1,
    fontSize: 14,
  },
  paymentCardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 1,
    mb: 0.5,
  },
  paymentCardName: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
  },
  paymentCardAmount: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    fontSize: 16,
  },
  paymentCardMeta: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
    fontSize: 13,
    mb: 0.5,
  },
  paymentCardDescription: {
    color: colorsConstants.primaryText,
    fontSize: 14,
  },
  automaticPaymentCard: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
  automaticPaymentCardHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 1,
    mb: 0.5,
    flexWrap: "wrap",
  },
  upcomingPaymentRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    py: 1.5,
    px: 0,
    flexWrap: "wrap",
    gap: 1,
    borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
  },
  upcomingBadge: {
    borderRadius: 1,
  },
  sectionTitle: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 2,
    mt: 1,
  },
  usersListParent: {
    p: 0,
  },
  usersListItem: {
    borderRadius: 2,
    mb: 1,
  },
  searchBox: {
    mb: 2,
    backgroundColor: "transparent",
  },
  composeFormContainer: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
  composeFormField: {
    mb: 2,
  },
  automaticSectionBox: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 130, 0, 0.18)",
    backgroundColor: "rgba(0, 180, 0, 0.04)",
    mb: 2,
  },
  submitButton: {
    mt: 1,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
